import type { LucideIcon } from 'lucide-react';
import { LayoutGrid, Package, Tag, Workflow } from 'lucide-react';
import type { ChangelogProductId } from '@/lib/changelog/changelog-sources';
import {
  changelogPainelPageHref,
  changelogVersionHref,
} from '@/components/painel/changelog/changelog-painel-utils';

export type ChangelogNavKey = 'changelog_overview' | 'changelog_versions' | 'changelog_categories';

export type ChangelogNavChild = {
  key: string;
  label: string;
  href: string;
  icon: LucideIcon;
};

const DEFAULT_CHANGELOG_PRODUCT: ChangelogProductId = 'xat';

/** Itens da área Changelogs no menu lateral (produto padrão: xat). */
export function getChangelogSidebarChildren(product: ChangelogProductId = DEFAULT_CHANGELOG_PRODUCT): ChangelogNavChild[] {
  return [
    { key: 'changelog_overview', label: 'Overview', href: changelogPainelPageHref(product, 'overview'), icon: LayoutGrid },
    { key: 'changelog_versions', label: 'Versões', href: changelogPainelPageHref(product, 'versions'), icon: Workflow },
    { key: 'changelog_categories', label: 'Categorias', href: changelogPainelPageHref(product, 'categories'), icon: Tag },
  ];
}

/** @deprecated Use `getChangelogSidebarChildren`. */
export const CHANGELOG_SIDEBAR_STATIC: ChangelogNavChild[] = getChangelogSidebarChildren();

export { changelogVersionHref };

export const CHANGELOG_SIDEBAR = {
  label: 'Changelogs',
  emoji: '📦',
  icon: Package,
} as const;
